import styled, { css } from 'styled-components';

export const Label = styled.label`
	display: block;
	font-size: 2rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.black};
	margin-top: ${({ marginTop }) => marginTop || '0'};
	margin-bottom: ${({ marginBottom }) => marginBottom || '1.5rem'};

	${({ small }) =>
		small &&
		css`
			font-family: ${({ theme }) => theme.fonts.ArimoRegular};
			font-size: 1.4rem;
			color: ${({ theme }) => theme.colors.textColor};
			margin-bottom: ${({ marginBottom }) => marginBottom || '0.5rem'};
		`};
`;

export const Info = styled.div`
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	margin-top: ${({ marginTop }) => marginTop || '0'};
	margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
`;
